import * as amplitude from '@amplitude/analytics-browser';
import {DeviceUUID} from 'device-uuid';
import {getUserId} from "./storage";
import {OnlyStringProps} from "../types";
import {env} from "./env";

export const initAmplitude = () => {
    amplitude.init(
        // @ts-ignore
        process.env.REACT_APP_AMPLITUDE_API_KEY,
        getUserId(),
        {
            defaultTracking: false,
            domain: window.location.hostname,
            includeReferrer: true,
            includeUtm: true,
            deviceId: new DeviceUUID().get()
        }
    );
};

export const logEvent = (event: AmplitudeEvent, eventProperties: OnlyStringProps = {}) => {
    amplitude.track(event, {
        ...eventProperties,
        page: window.location.pathname,
        env: env()
    });
};

export enum AmplitudeEvent {
    BTN_CLICK = "ButtonClick",
    LANGUAGE_CHANGE = "LanguageChange",
    PAGE_VIEW = "PageView",
    NAVIGATION_CLICK = "NavigationClick"
}
